import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { InformationChip } from '@europrocurement/flexy-components';
import { useResponsive } from '@europrocurement/l2d-hooks';
import { IconName } from '@fortawesome/fontawesome-svg-core';

export type PanierElementDateToChipProps = {
    ttcRestant: string;
    dateEcheance?: string;
    type?: 'recouvrement' | 'paiement';
};

const PanierElementDateToChip: React.FunctionComponent<PanierElementDateToChipProps> = function ({
    ttcRestant,
    dateEcheance,
    type = 'paiement',
}) {
    const currentDate: string = new Date().toISOString();
    const { isSmallScreen } = useResponsive();
    let statusText = '';
    let icon = 'warning';
    let color: 'error' | 'success' | 'primary' | 'secondary' | 'warning' = 'error';
    let colortexte;
    if (ttcRestant === '0') {
        statusText = 'Réglée';
        colortexte = 'success.dark';
        color = 'success';
        icon = 'circle-check';
    } else if ((dateEcheance && dateEcheance > currentDate) || dateEcheance === undefined) {
        statusText = type === 'paiement' ? 'En attente' : 'Non échue';
        colortexte = 'danger.dark';
        color = 'warning';
        icon = 'clock-two-thirty';
    } else {
        statusText = type === 'paiement' ? 'En retard' : 'Échue';
        colortexte = 'error.dark';
        color = 'error';
        icon = 'circle-exclamation';
    }
    return (
        <Tooltip title={statusText}>
            <Box>
                <InformationChip
                    label={
                        <Typography
                            color={colortexte}
                            display="flex"
                            gap="5px"
                        >
                            <FaOptionIcon icon={['fasl', icon as IconName]} />
                            {isSmallScreen ? null : statusText}
                        </Typography>
                    }
                    color={color}
                />
            </Box>
        </Tooltip>
    );
};

export default PanierElementDateToChip;
